export const PROFILE_RUN_DEEP_LINK_EVENT_NAME = 'run-profile-with-external-protocol';
export const PROFILE_SHARE_DEEP_LINK_EVENT_NAME = 'share-profile-with-external-protocol';
